/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SendPasswordResetResponseStatus {
  Success = 0,
  EmailIsNotValidOrCredentialsDoNotMatch = 1,
  InactiveUser = 2,
  ShouldFollowInvitationLink = 3,
  ShouldRequestNewInvitationLink = 4,
}
